import React from 'react';
import { Tooltip } from 'antd';

/**
 * @typedef {object} MultilineTextWithTooltipProps
 * @property {string} [value]
 * @property {number} [maxRowNumber]
 */

/**
 * @param {MultilineTextWithTooltipProps} props
 */
const MultilineTextWithTooltip = props => {
  const { value, maxRowNumber = 4 } = props;

  return (
    <Tooltip title={value}>
      <div className='multiline-text-with-tooltip' style={{ WebkitLineClamp: maxRowNumber }}>
        {value}
      </div>
    </Tooltip>
  );
};

export default MultilineTextWithTooltip;
